<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "AddPartnerButton"
})
</script>

<template>
<router-link tag="div" :to="{name: 'create-partner'}" class="add-partner">
    <div>
        +
    </div>
    <div>
        Додати точку
    </div>
</router-link>
</template>

<style scoped>
.add-partner {
    /* Buttons */
    cursor: pointer;
    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;

    width: 200px;
    height: 44px;

    border: 1px solid #FB923C;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    font-family: 'Geist',serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    color: #FB923C;
    gap: 10px;
}
</style>
